module.exports = __webpack_public_path__ + "img/Time_Zone.ab2956b9.svg";